const SYMBOL_TO_CURRENCY = {
    '£': 'GBP',
    $: 'CAD',
    R$: 'BRL',
    '€': 'EUR',
    Kč: 'CZK',
}

export const currencyFromSymbol = symbol => SYMBOL_TO_CURRENCY[symbol]
